import { render, staticRenderFns } from "./index.vue?vue&type=template&id=782802d1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=782802d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782802d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782802d1')) {
      api.createRecord('782802d1', component.options)
    } else {
      api.reload('782802d1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=782802d1&scoped=true", function () {
      api.rerender('782802d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/open-guide/index.vue"
export default component.exports